import _ from 'lodash';
import { useEffect, useReducer } from 'react';
import socket from '~/app/socketio';
import { log } from '@swiper/core';

function reducer( state, action ) {
  if ( action.error && _.isError( action.error ) ) {
    action.error = action.error.message;
  }
  if ( action.error && ! action.status ) action.status = 'error';
  log.debug( 'Network status changed', action );
  return ( action.status === 'connected' ) ? action : { ...state, ...action };
}

export function useNetworkStatus() {
  const [ state, dispatch ] = useReducer( reducer, { status : 'connected' } );

  useEffect( () => wrap_events( socket, {
    connect() { dispatch( { status : 'connected' } ); },
    reconnect() { dispatch( { status : 'connected' } ); },
    disconnect( error ) { dispatch( { status : 'disconnected', error } ); },
    error( error ) { dispatch( { error } ); },
    connect_error( error ) { dispatch( { error } ); },
    reconnect_error( error ) { dispatch( { error } ); },
    connect_timeout() { dispatch( { status : 'timeout' } ); },
    reconnecting( attempt ) { dispatch( { attempt } ); },
  } ), [ dispatch ] );

  return state;
}

function wrap_events( emitter, events ) {
  const cleanup = _.map( events, ( func, name ) => {
    socket.on( name, func );
    return () => socket.off( name, func );
  } );
  return () => cleanup.forEach( x => x() );

}
